import { defineStore } from 'pinia';
import { screens } from '@/utilities/screen';

export const useLayoutStore = defineStore('layout', {
  state: () => ({
    // Closed on a phone: there the nav is a full-screen modal, so it must not open on reload.
    sidebarOpen: window.innerWidth >= screens.sm,
  }),
  actions: {
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
    },
  },
});
